"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HorizontalRangeLegend;
var _react = _interopRequireDefault(require("react"));
var _labelFormatter = require("../../utils/label-formatter");
var _styled = require("./styled");
function HorizontalRangeLegend(_ref) {
  let {
    palette,
    min,
    mid,
    max,
    format
  } = _ref;
  const midPoint = Math.round((Number(mid) - Number(min)) / (Number(max) - Number(min)) * 100);
  const background = palette.length === 2 ? "linear-gradient(90deg, ".concat(palette[0], " 0%, ").concat(palette[1], " 100%)") : "linear-gradient(90deg, ".concat(palette[0], " 0%, ").concat(palette[1], " ").concat(midPoint, "%, ").concat(palette[2], " 100%)");
  return /*#__PURE__*/_react.default.createElement(_styled.HorizontalRangeLegendGradient, null, /*#__PURE__*/_react.default.createElement(_styled.MinValue, null, _labelFormatter.QuantitativeFormatter[format](min)), /*#__PURE__*/_react.default.createElement(_styled.RangeBand, {
    style: {
      background
    }
  }), /*#__PURE__*/_react.default.createElement(_styled.MaxValue, null, _labelFormatter.QuantitativeFormatter[format](max)));
}